export function set(key, value) {
  return localStorage.setItem(key, JSON.stringify(value));
}

export function get(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function remove(key) {
  return localStorage.removeItem(key);
}

export function getAll() {
  return Object.keys(localStorage);
}

export function removeAll() {
  localStorage.clear();
}
